var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window-frame',{attrs:{"titleText":"開発履歴 on Twitter   「みんなありがとう！！！！！」","display-property":"private.display.devLogWindow","align":"left-top","fixSize":"385, 660"}},[_c('iframe',{attrs:{"src":"./static/DevelopHistory.html"}})])}
var staticRenderFns = []

export { render, staticRenderFns }